import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { Button as StyledButton } from '../../Button';
import { Input } from '../LegacyPhoneNumberWidget/PhoneNumberWidget.styles';

import arrow from '@/images/arrow-icon.svg';

export const GetStartedWrapper = styled('div')`
  display: flex;
  max-width: ${pxToRem(160)};
  width: ${pxToRem(160)};

  & > div {
    height: ${pxToRem(32)};
  }

  ${mediaQueries.desktop} {
    & > div {
      height: ${pxToRem(40)};
    }
  }
`;

export const GetStartedButton = styled(StyledButton, {
  shouldForwardProp: (prop) => prop !== 'showIcon'
})<{ showIcon: boolean }>`
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
  z-index: 1;
  -webkit-tap-highlight-color: transparent;
  height: ${pxToRem(32)};

  ${({ showIcon, theme }) =>
    showIcon
      ? `
          padding: 0 ${theme.spacing.s};
          width: ${pxToRem(42)};
          flex-grow: 0;
          color: rgba(0, 0, 0, 0);

          &:hover, :focus, :active {
            color: rgba(0, 0, 0, 0);
          }
        `
      : { width: pxToRem(160), flexGrow: 1 }};

      ${mediaQueries.tablet} {
        min-width: 0;
      }

  &::before {
    ${({ showIcon }) =>
      showIcon
        ? `
        content: '';
        background: url(${arrow.src});
        height: 100%;
        width: 100%; 
        background-repeat: no-repeat;
        background-position: center;
        display: inline-block;
      `
        : `
        height: ${pxToRem(16)};
        width: ${pxToRem(22)}; 
      `}

  transition: all 0.1s cubic-bezier(0, 0.7, 0.3, 1.01);
  will-change: width, flex-grow;
`;

export const GetStartedInput = styled(Input, {
  shouldForwardProp: (prop) => prop !== 'isStartClicked'
})<{ isStartClicked: boolean }>`
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.input};

  ${({ isStartClicked, theme }) =>
    isStartClicked
      ? { flexGrow: 1, padding: `0 ${theme.spacing.sm}`, opacity: 1 }
      : {
          flexGrow: 0,
          width: 0,
          padding: 0,
          border: 0,
          marginRight: 0,
          opacity: 0
        }};

  ::placeholder {
    font-size: ${({ theme }) => theme.fontSize['3xs']};
  }

  transition: flex-grow 0.1s cubic-bezier(0, 0.7, 0.3, 1.01);
`;
